import * as React from 'react';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Button from '../../components/forms/button'
import * as CONST from '../../helpers/const';
import Utils from '../../helpers/utils';
import { isMobile } from 'react-device-detect';

const ICA0111Table = (props) => {
  if (props === null) { return ""; }
  let datalist = props.data ? props.data : [];

  var pageNo = props.pageNo;
  const sizePerPageList = [
    { text: '10件', value: 10 },
    { text: '25件', value: 25 },
    { text: '50件', value: 50 },
    { text: '100件', value: 100 },
  ];

  var selectedSize = sizePerPageList.filter(option => option.value == props.sizePerPage)[0];
  if (selectedSize === null || selectedSize === undefined) {
    selectedSize = sizePerPageList[0];
  }

  var sizePerPage = selectedSize.value;

  const options = {
    paginationShowsTotal: renderShowTotal,
    sizePerPageList: sizePerPageList,
    page: pageNo,
    sizePerPage: isNaN(sizePerPage) ? sizePerPage : parseInt(sizePerPage),
    paginationSize: 4,
    paginationPosition: "both",
    hideSizePerPage: true,
    noDataText: renderNoDataText(),
    onPageChange: onPageChange
  };

  var pagination = true;
  
  function onPageChange(pageNo, sizePerPage) {
    props.setPageNo(pageNo);
    props.setSizePerPage(sizePerPage);
  }
  
  function renderShowTotal(start, to, total) {
    let totalText = props.getTranslateValue(props.translate.current, "views.shared.showtotal");
    let tokens = totalText.split('[');
    let firstHalf = tokens[0].replace(/\{0\}/g, total);
    firstHalf = `${start}-${to}${firstHalf}`
    let secondHalf = tokens[1].split(']')[1]
    let displayPagination = datalist.length === 0 ? "d-none" : "d-block";
    return (
      <div className={displayPagination} style={{ marginBottom: "4px" }}>
        <span>{firstHalf}</span>
        {!isMobile && (
          <div>
            <RenderSizeDropdown />
            <span>{secondHalf}</span>
          </div>
        )}
      </div>
    )
  }
  
  function RenderSizeDropdown() {
    return (
      <span className="dropdown react-bs-table-sizePerPage-dropdown" >
        <select value={selectedSize.value} className="multiselect dropdown-toggle input-group-text" style={{ display: "inline-grid" }} onChange={e => props.setSizePerPage(e.target.value)}>
          {
            sizePerPageList.map(function (option, index) {
              return <option key={index} value={option.value}>{option.text}</option>
            })
          }
        </select>
      </span>
    )
  }
  
  function renderNoDataText() {
    if (props.isFetching) {
      return props.getTranslateValue(props.translate.current, "views.table.retrieving");
    } else {
      return props.getTranslateValue(props.translate.current, "messages.common.norecord");
    }
  }

  function renderNumbers(cell, row, enumObject, index) {
    return cell.toLocaleString('en');
  }

  function renderProduct(cell, row, enumObject, index) {
      
    var imageUrl = row.ImgSrc;
      if (null != imageUrl && !(imageUrl.indexOf("data:image") != -1)) {
          
          imageUrl = window.baseUrl + imageUrl; //support no app alias
        }
       
        if(isMobile){
          return ( 
            <div className="row" style={{ display: "flex", alignItems: "center", height: "100%", marginLeft: "0px" , marginRight: "0px"  }} > 
              <div className="col-sm-12 col-md-3 col-lg-2" style={{ textAlign: "center", paddingRight:  "5px", paddingLeft:"5px" , width: "80px" , flex: "0 0 80px"  }} > 
                <img className="display-hansoku-web" src={imageUrl} style={{ width: "65px" , height: "65px" , objectFit: "contain", maxHeight:"65px" , maxWidth: "65px" }} /> 
              </div>
              <div className="col-sm-12 col-md-6 col-lg-7" style={{ height: "100%", textAlign: "left", justifyContent: "center", paddingLeft: "0px", paddingRight: "5px", minWidth:  "0px" , flex: "1 1 auto", width: "auto"  }} > 
                <p style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: "2px", marginTop:  "5px" , }} > 
                  {row.BunruiName1} 
                </p> 
                <p style={{ cursor: "pointer", display: "block", overflowWrap: "break-word", whiteSpace: "pre-wrap", marginBottom: "0px", }} >
                  {row.HansokuName} ({row.HansokuCode}) 
                </p> 
              </div> 
             </div> 
          ); 
        }

        return (
            <div className="row" style={{ display: "flex", alignItems: "left", height: "100%" }} >
                <div className="col-sm-12 col-md-3 col-lg-2" style={{ textAlign:"center", paddingRight:"5px" }}>
                    <img className="display-hansoku-web" src={imageUrl} style={{ height:"100%", width:"auto", objectFit:"contain", maxHeight:"65px", maxWidth:"100%" }} />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-7" style={{ height: "100%",  textAlign: "left", justifyContent: "center", paddingLeft: "0px", paddingRight: "10px" }} >
                    <p style={{  display: "block",  whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",  marginBottom: "2px", marginTop: "10px", }} >
                      {row.BunruiName1}
                    </p>
                    <p style={{ cursor: "pointer", display: "block", overflowWrap: "break-word", whiteSpace: "pre-wrap", marginBottom: "0px", }} >
                      {row.HansokuName} ({row.HansokuCode}) </p>
                </div>
            </div>
        );
  }
  
  return (
    <BootstrapTable hover data={datalist} options={options} pagination={pagination} tableHeaderClass="table-header-style" tableBodyClass="table-body-style">
      <TableHeaderColumn dataField="HansokuId" hidden isKey ></TableHeaderColumn>
      <TableHeaderColumn dataField="HansokuName" dataFormat={renderProduct.bind(this)} width= {isMobile ? "70%" :"80%"} tdStyle={{ textAlign: 'center' }}>
        {props.getTranslateValue(props.translate.current, "views.ica0111.productname")}
      </TableHeaderColumn>
      <TableHeaderColumn dataField="IraiQt" dataFormat={renderNumbers.bind(this)} width= {isMobile ? "30%" :"20%"} tdStyle={{ textAlign: 'center' }}>
        {props.getTranslateValue(props.translate.current, "views.ica0111.quantity")}
      </TableHeaderColumn>
    </BootstrapTable>
  );  
}

export default ICA0111Table;


// WEBPACK FOOTER //
// ./view/ICA0111/ica0111-table.jsx